export interface Common {
    motcle?: string;
    delYn: string;
    inpDt: any;
    cdOrd: number;
    cd: string;
    cdNmKo: string;
    coCommonCdId: number;
    cdNmAr: string;
    cdCls: string;
    cdNmFr: string;
    useYn: string;
    inpPer: string;
    cdNm: string;
}

export function isPersonnemorale(value: any) {
    return value == 1;
}

export function isPersonnePhysique(value: any) {
    return value == 4;
}

export function isEntrpriseEtrangere(value: any) {
    return value == 5;
}

export function isArtisant(value: any) {
    return value == 2;
}

export function isGroupeArtisant(value: any) {
    return value == 3;
}
